export default "__VITE_ASSET__Q4s$RF_X__"